import { render, staticRenderFns } from "./SGPRadioGroupComponent.vue?vue&type=template&id=d1c5f678"
import script from "./SGPRadioGroupComponent.vue?vue&type=script&lang=js"
export * from "./SGPRadioGroupComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports